import axios from "axios";

export const state = {
    prescription_status: false,
    visit_prescription: [],
};
export const getters = {
    prescriptionStatus: state => state.prescription_status,
    VisitPrescription: state => state.visit_prescription.data,

};
export const mutations = {
    SET_PRESCRIPTION_STATUS(state, newValue) {
        state.prescription_status = newValue
    },
    SET_VISIT_PRESCRIPTION(state, newValue) {
        state.visit_prescription = newValue
    },
    REMOVE_VIST_PRES(state, index) {
        state.visit_prescription.data.splice(index, 1);
    },
};
export const actions = {
    addPrescriptions({ commit, dispatch }, payload) {
        commit('SET_PRESCRIPTION_STATUS', true)
        axios.post('prescriptions', payload).then(response => {
            commit('SET_PRESCRIPTION_STATUS', false)
            dispatch('fetchVisitPrescriptions', payload.visit_id)
            if (response.status==200){
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            }else {
                let message = { 'msg': "Error adding prescription" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_PRESCRIPTION_STATUS', false)
            let message = { 'msg': "Error adding prescription, confirm the drug hasn't been added to the patient and try again" }
            dispatch('notification/error', message, { root: true })
        })
    },
    fetchVisitPrescriptions({ commit }, visit_id) {
        axios.get(`prescriptions/${visit_id}`).then((vp_res) => {
            commit('SET_VISIT_PRESCRIPTION', vp_res.data)
            commit('SET_PRESCRIPTION_STATUS', false)
        })
    },

    updatePrescription({ commit,dispatch }, prescription) {
        axios.put(`prescriptions/${prescription.id}`, prescription).then(response => {
            commit('SET_PRESCRIPTION_STATUS', false)
            if (response.status==200){
                let message = { 'msg': response.data.msg }
                dispatch('notification/success', message, { root: true })
            }else {
                let message = { 'msg': 'Prescription updating failed' }
                dispatch('notification/error', message, { root: true })
            }
        })
    },

    removePrescription({ dispatch }, prescription) {
        axios.delete(`prescriptions/${prescription.id}`).then(() => {
            let message = { 'msg': "Prescription removed successfully" }
                // DISPATCH MESSAGE MODULE
            dispatch('notification/success', message, { root: true })
        }).catch(() => {
            let message = { 'msg': "Error removing prescription" }
            dispatch('notification/error', message, { root: true })
        })
    },
};